export default "__VITE_ASSET__11f73e6c__"